export default __webpack_public_path__ + "static/61-4e0548044a004d62e3c6684d1814cb4e.png";